import type { Middleware, AnyAction } from '@reduxjs/toolkit';
import { getAllTasks } from '~/reducers/tasksSlice';
import type { SelectedClientState } from '~/reducers/selectedClientsSlice';
import dateUtils from '~/utils/date-utils';

interface PartialState {
    /**
     * Selected date managed by selectedDateSlice
     */
    selectedDate: string | null;
    /**
     * Selected client ids managed by selectedClientSlice
     */
    selectedClients: SelectedClientState;
}

export const requestAllTasksOnSelectionChange: Middleware<
    unknown,
    PartialState
> = (store) => (next) => (action) => {
    const ACTIONS: Record<string, boolean> = {
        'selectedDate/setSelectedDate': true,
        'selectedClientIds/setSelectedClientIds': true,
        'webSolution/setWebSolution': true
    };

    const result = next(action);

    const { selectedDate } = store.getState();
    const selectedClientIds = Object.keys(store.getState().selectedClients);

    if (selectedDate && ACTIONS[action.type]) {
        store.dispatch(
            getAllTasks({
                routeDate: dateUtils.convertToISODateOnly(selectedDate) || '',
                selectedClientIds
            }) as unknown as AnyAction
        );
    }

    return result;
};
